import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IconsModule } from "@va/core-library/icons";
import { NotificationRendererComponent } from "./notification-renderer.component";

@NgModule({
  declarations: [NotificationRendererComponent],
  imports: [CommonModule, IconsModule],
  exports: [NotificationRendererComponent],
})
export class NotificationRendererModule {}
